export default "__VITE_ASSET__DlR3HYW7__"